import { EditSecretaryProfile, EditSecretaryPassword } from "./";

export const SettingsSecretary = () => {
  return (
    <div className="tab-pane fade show active">
      <h5 className="mb-1">Configuraciones</h5>
      <div className="row">
        <div className="col-lg-6">
          <EditSecretaryProfile />
        </div>
        <div className="col-lg-6">
          <EditSecretaryPassword />
        </div>
      </div>
    </div>
  );
};
